import {useFormContext} from "react-hook-form";
import {FiTrash} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {Divider} from "@/components/divider/Divider.tsx";
import {FormLabel} from "@/components/form/FormLabel.tsx";
import {ScheduleWeekday, sortWeekdays, WEEKDAYS, WeekNames} from "@/components/form/maintenance/types.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {Select} from "@/components/select/Select.tsx";
import {TimeInput} from "@/components/timeInput/TimeInput.tsx";

interface WeeklyScheduleRowProps {
  id: string;
  name: string;
  index: number;
  remove: (index: number) => void;
}

export const WeeklyScheduleRow = ({id, name, index, remove}: WeeklyScheduleRowProps) => {
  const {setValue, watch, clearErrors} = useFormContext();
  return (
    <div key={`weekly-${id}`}>
      <div className="row g-3">
        <div className="col-12 col-md-5">
          <FormLabel forId={`${name}.${index}.weekdays`}>Day</FormLabel>
          <Select
            placeholder="Select day"
            name={`${name}.${index}.weekdays`}
            value={watch(`${name}.${index}.weekdays`)
              .sort(sortWeekdays)
              .map((d: number) => ({
                value: d,
                label: WeekNames[d as ScheduleWeekday],
              }))}
            onChange={(v) => {
              setValue(
                `${name}.${index}.weekdays`,
                v.map((x) => x.value),
                {shouldDirty: true, shouldValidate: true}
              );
            }}
            options={WEEKDAYS.map((d) => ({
              value: d,
              label: WeekNames[d],
            }))}
            isMulti={true}
          />
        </div>
        <div className="col-12 col-md-3">
          <FormLabel forId={`${name}.${index}.from_time`}>Start</FormLabel>
          <TimeInput
            name={`${name}.${index}.from_time`}
            defaultValue={"00:00"}
            value={watch(`${name}.${index}.from_time`)}
            onTimeChange={(val) => {
              clearErrors([name]);
              setValue(`${name}.${index}.from_time`, val, {shouldDirty: true, shouldValidate: true});
            }}
          />
        </div>
        <div className="col-12 col-md-3">
          <FormLabel forId={`${name}.${index}.to_time`}>End</FormLabel>
          <TimeInput
            name={`${name}.${index}.to_time`}
            defaultValue={"24:00"}
            value={watch(`${name}.${index}.to_time`)}
            onTimeChange={(val) => {
              clearErrors([name]);
              setValue(`${name}.${index}.to_time`, val, {shouldDirty: true, shouldValidate: true});
            }}
          />
        </div>
        <div className="col-12 col-md-1 d-flex align-items-end justify-content-md-center">
          <Button
            variant="ghost"
            size="fitContent"
            onClick={() => {
              remove(index);
            }}
          >
            <Icon icon={FiTrash} className="m-md-2" />
            <span className="d-md-none d-inline-block">Remove Schedule</span>
          </Button>
        </div>
      </div>
      <div>
        <Divider className="my-3" />
      </div>
    </div>
  );
};
